import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";

export class WechatMenuService extends BaseService {
  public loadParentMenus(id: number, success: Success, failure?: Failure) {
    super.get("/api/wechat/menu/list/query/parent", { id }).then(
      function(result) {
        success(result.data.list);
      },
      function(error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public createMenu(success: Success, failure?: Failure) {
    super.get("/api/wechat/menu/create", {}).then(
      function(result) {
        success(result.data);
      },
      function(error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }
}
